  import Vue from 'vue'
  import App from './App'
  import axios from 'axios'
  import BaseMethod from "./util/baseMethod.js";
  import './util/rem'
  import { Input ,Button, Icon, message,pagination,Modal, notification} from 'ant-design-vue';

  import store from './store'


  Vue.use(BaseMethod)
  Vue.use(Input).use(Button).use(Icon).use(pagination)


  axios.defaults.timeout = 10000;
  // axios.defaults.headers.post['Is-Dev'] = '1'
  const Domain = 'https://php-activity-api.meiamjsa11.com'
  Vue.prototype.$axios = axios;
  Vue.prototype.$message = message
  Vue.prototype.$modal = Modal
  Vue.prototype.$Domain = Domain
  Vue.prototype.$BaseUrl = `${Domain}/XYLP/api`
  Vue.prototype.$notification = notification
  Vue.config.productionTip = false
  new Vue({
    store,
    render: h => h(App),
  }).$mount('#app')
